import { render, staticRenderFns } from "./CMMainPage.vue?vue&type=template&id=24083832&"
import script from "./CMMainPage.vue?vue&type=script&lang=js&"
export * from "./CMMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24083832')) {
      api.createRecord('24083832', component.options)
    } else {
      api.reload('24083832', component.options)
    }
    module.hot.accept("./CMMainPage.vue?vue&type=template&id=24083832&", function () {
      api.rerender('24083832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accounts/CMMainPage.vue"
export default component.exports